import React from "react"

import { thousandSeparator } from "utils"
import Card from "./Card"
import Button from "./Button"
import { LazyImage } from "components"
import classes from "./ComboCard.module.scss"

const ComboCard = props => {
  const {
    foodItem,
    showButton,
    onButtonPress,
    buttonText
  } = props

  return (
    <Card className={classes["card"]}>
      <div className={classes["left"]}>
        <LazyImage
          src={foodItem.imageCover}
          imageWidth={300}
          quality={80}
          className={classes["image"]}
        />
        <div className={classes["info"]}>
          <div className={classes["description"]}>
            {foodItem.foodName}
          </div>
          <div className={classes["code"]}>
            کد: {foodItem.foodCode}
          </div>
          <b>
            {thousandSeparator(foodItem.salePrice)}
          </b>
        </div>
      </div>
      {
        showButton &&
        <Button
          onClick={onButtonPress}
        >
          {buttonText}
        </Button>
      }
    </Card>
  )
}

export default ComboCard